import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./app/contexts/AuthContext";
import {ToastContainer} from "react-toastify";
import {AppRoutes} from "./app/routing/AppRoutes";
import {BrowserRouter} from "react-router-dom";
import {HeaderProvider} from "./app/contexts/HeaderContext";

const {PUBLIC_URL} = process.env;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={PUBLIC_URL}>
    <AuthProvider>
      <HeaderProvider>
        <AppRoutes/>
        <ToastContainer toastClassName="text-xs font-light" position="bottom-right" theme="colored" autoClose={5000}/>
      </HeaderProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
